import type { I18nT } from "@lib/dashboardI18n";
import sharedConstants from "@lib/shared_constants";

import { getRcsSuggestedActionsSchema } from "./rcsSuggestedActionsSchema";
import type { RcsSuggestedActionSchemaOptions } from ".";

export function getRcsRichCardButtonSchemaErrorStrings(
  t: I18nT<"rcs-composer">
): RcsSuggestedActionSchemaOptions["errorStrings"] {
  return {
    minActionsError: t("min-rich-card-buttons-error", "At least { minActions, number } button is required", {
      minActions: sharedConstants.RCS.VALIDATIONS.MIN_NUMBER_RICH_CARD_BUTTONS,
    }),
    maxActionsError: t("max-rich-card-buttons-error", "{ maxActions, number }/{maxActions, number} buttons added", {
      maxActions: sharedConstants.RCS.VALIDATIONS.MAX_NUMBER_RICH_CARD_BUTTONS,
    }),
    actionTypeRequired: t("rcs-rich-card-button-type-required", "Type is required"),
    actionTextRequired: t("rcs-rich-card-button-text-required", "Text is required"),
    actionTextLengthError: t(
      "rcs-suggested-action-text-length-error",
      "Text must be { maxTextLength, number } characters or fewer",
      {
        maxTextLength: sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_TEXT_SUGGESTION,
      }
    ),
    actionUrlLengthError: t(
      "rcs-suggested-action-url-length-error",
      "Website URL must be {maxUrlLength, number} characters or fewer",
      {
        maxUrlLength: sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_URL_SUGGESTION,
      }
    ),
    actionUrlRequired: t("rcs-suggested-action-url-required", "Website URL is required"),
    actionUrlInvalidError: t("rcs-suggested-action-website-url-invalid-error", "Website URL is invalid"),
  };
}

export const getRcsRichCardButtonSchema = (t: I18nT<"rcs-composer">) =>
  getRcsSuggestedActionsSchema(t, {
    minActions: sharedConstants.RCS.VALIDATIONS.MIN_NUMBER_RICH_CARD_BUTTONS,
    maxActions: sharedConstants.RCS.VALIDATIONS.MAX_NUMBER_RICH_CARD_BUTTONS,
    errorStrings: getRcsRichCardButtonSchemaErrorStrings(t),
  });
